package one.healthium.ui.compose.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import one.healthium.ui.compose.theme.AppTheme
import one.healthium.ui.compose.theme.gray_1

@Composable
fun AppPageIndicator(
    modifier: Modifier = Modifier,
    size: Dp = 7.5.dp,
    activeColor: Color = AppTheme.colors.primary,
    inactiveColor: Color = gray_1,
    pages: Int,
    currentPage: Int,
) {
    Row(
        modifier = modifier,
        horizontalArrangement = Arrangement.spacedBy(10.dp)
    ) {
        repeat(pages) { page ->
            Dot(
                active = page == currentPage,
                size = size,
                activeColor = activeColor,
                inactiveColor = inactiveColor,
            )
        }
    }
}

@Composable
private fun Dot(
    active: Boolean,
    size: Dp,
    activeColor: Color,
    inactiveColor: Color,
) {
    Box(
        modifier = Modifier
            .size(size)
            .background(
                color = if (active) activeColor else inactiveColor,
                shape = RoundedCornerShape(50),
            )
    )
}